export type ClaimKind = 'checkable' | 'prediction' | 'imagination';

export const CLAIM_KIND_LABELS: Record<ClaimKind, string> = {
    checkable: '확인 가능한 주장',
    prediction: '미래 예측',
    imagination: '비유·상상'
};

export const WEEKLY_CLAIMS: {
    postId: number;
    quote: string;
    category: string;
    kind: ClaimKind;
    explanation: string;
}[] = [
    {
        postId: 238,
        quote: '나무보다 상어가 훨씬 더 오래 살았다고?',
        category: '과학',
        kind: 'checkable',
        explanation: '나무와 상어가 언제 나타났는지 자료를 찾아 비교할 수 있는 과거 사실 주장입니다. 여기서는 참·거짓 자체를 판정하지 않습니다.'
    },
    {
        postId: 244,
        quote: 'AI가 코딩을 대신한다면, 개발자는 사라질까?',
        category: 'IT',
        kind: 'prediction',
        explanation: '앞으로 직업이 어떻게 바뀔지에 대한 예상입니다. 현재의 사례와 전망을 구분해 이야기해 볼 수 있습니다.'
    },
    {
        postId: 233,
        quote: '냉장고는 시간을 얼리는 마법 상자입니다',
        category: '기타',
        kind: 'imagination',
        explanation: '시간이 실제로 멈춘다는 측정 주장보다, 냉장고를 재미있게 묘사한 비유·상상으로 읽는 편이 자연스럽습니다.'
    }
];

export const WEEKLY_PHOTO = {
    id: 63,
    imageUrl: '/uploads/weekly-evidence-2026-10-24.jpg',
    alt: '나무 탁자 위에 놓인 크림색 봉투 세 통과 돋보기, 창가에서 드리운 햇빛과 붉은 실',
    href: '#/board?tab=PHOTO&photo=63'
};

export const MIRROR_PHOTO = {
    id: 64,
    imageUrl: '/uploads/weekly-mirror-2026-10-31.jpg',
    alt: '햇빛이 비치는 나무 탁자 위의 타원형 거울, 줄무늬 양말 한 짝, 빈 종이와 연필',
    href: '#/board?tab=PHOTO&photo=64'
};

export const photoAlt = (photo: { imageUrl: string; title?: string }) =>
    photo.imageUrl === MIRROR_PHOTO.imageUrl ? MIRROR_PHOTO.alt
        : photo.imageUrl === WEEKLY_PHOTO.imageUrl ? WEEKLY_PHOTO.alt
            : photo.title || '커뮤니티에 공유된 사진';
